<script lang="ts" setup>
defineEmits(['select-item']);
defineProps<{ items: { id: string | number; title: string; isSelected: boolean }[]; isLoading?: boolean }>();
</script>

<template>
  <div class="switch-btn-group">
    <button
      v-for="item in items"
      :key="item.id"
      :class="{ 'switch-btn-group__btn--selected': item.isSelected }"
      :disabled="isLoading"
      class="switch-btn-group__btn"
      @click="$emit('select-item', item.id)"
    >
      {{ item.title }}

      <slot name="after-title" />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.switch-btn-group {
  display: flex;
  gap: 4px;
  justify-content: center;
  padding: 2px;
  border-radius: 8px;
  background-color: $hell-black-5;

  &__btn {
    display: flex;
    flex: 1;
    gap: 4px;
    justify-content: center;
    align-items: center;
    height: 34px;
    padding: 2px 6px;
    border-radius: 6px;
    color: $hell-black-60;
    transition: all 0.3s;

    &:hover {
      @include screen-md {
        background-color: $white-05;
        color: $hell-black-80;
      }
    }

    &--selected {
      background-color: $white;
      color: $hell-black;

      &:hover {
        background-color: $white;
        color: $hell-black;
      }

      &:first-of-type {
        box-shadow: 4px 0 6px 0 rgb(0 0 0 / 5%);
      }

      &:last-of-type {
        box-shadow: -4px 0 6px 0 rgb(0 0 0 / 5%);
      }

      &:only-of-type,
      &:not(:first-of-type, :last-of-type) {
        box-shadow: -1px 1px 9.3px 1px rgb(0 0 0 / 5%);
      }
    }
  }
}
</style>
